import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, AlertController, IonInput } from '@ionic/angular';
import { CartService } from '../../services/cart.service';
import { Decimal } from 'decimal.js';
import { StorageService } from 'src/app/services/storage.service';

@Component({
    selector: 'app-checkout-payment-external-card',
    templateUrl: './checkout-payment-external-card.page.html',
    styleUrls: ['./checkout-payment-external-card.page.scss'],
})
export class CheckoutPaymentExternalCardPage implements OnInit {

    @ViewChild('payment_amount_input', { static: false }) payment_amount_input: IonInput;

    cart = null;
    payment = {
        method: 'external_card',
        price: null,
        label:'External card'
    };
    payment_amount = null;
    surcharge_rate = null;
    surcharge_price = null;
    surcharge_enabled = false;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.cartService.get().then((cart) => {
            if (cart) {
                this.cart = cart;
                this.storageService.get('order_credit_card_surcharge_rate').then((credit_card_surcharge_rate) => {
                    if (credit_card_surcharge_rate && credit_card_surcharge_rate > 0) {
                        this.surcharge_enabled = true;
                        this.surcharge_rate = Number(credit_card_surcharge_rate);
                    }
                    this.payment.price = cart['amount_due'];
                    this.payment_amount = cart['amount_due'].toFixed(2);
                    this.calculatePricing();    
                });
            }
        });
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.payment_amount_input) {
                this.payment_amount_input.setFocus();
            }
        }, 200);
    }

    calculatePricing() {

        // ensure payment isn't over the amount due
        if(this.payment.price > this.cart.amount_due) {
            this.payment.price = this.cart.amount_due;
        }
        
        if(this.surcharge_enabled && this.surcharge_rate && this.surcharge_rate > 0) {
            try {
                this.surcharge_price = Number(new Decimal(this.payment.price).times(new Decimal(this.surcharge_rate).dividedBy(100)).toDecimalPlaces(2));
                this.payment.price = Number(new Decimal(this.payment.price).add(new Decimal(this.surcharge_price)).toDecimalPlaces(2));
            }
            catch(e) {
                // If error, invalid number
                // decimal.js recommended way to check for DecimalError
                if(e instanceof Error && /DecimalError/.test(e.message)) {
                    // So disable option to add payment
                    this.payment.price = null;
                }
            }
        } 
    }

    sanitisePaymentAmount() {

        let payment_amount = this.payment_amount.toString();
        
        // only accept numbers/decimal points
        if(/[^0-9.]/.test(payment_amount)) {
            this.payment.price = null;
        }        
        else if(payment_amount.startsWith('.')) {
            this.payment.price = null;
        }
        else if(payment_amount.endsWith('.')) {
            this.payment.price = null;
        }              
        else if(payment_amount.split('.').length > 2) {
            this.payment.price = null;
        }
        else if(!payment_amount.length) {
            this.payment.price = null;
        }
        else {
            this.payment.price = Number(new Decimal(payment_amount).toDecimalPlaces(2));
        }

        this.calculatePricing();

    }    

    toggleSurcharge() {
        this.payment.price = this.payment_amount;
        this.calculatePricing();
    }

    addPayment() {

        if(this.surcharge_enabled && this.surcharge_rate && this.surcharge_rate > 0) {
            this.payment['surcharge_rate'] = this.surcharge_rate;
        }

        this.cartService.addPayment(this.payment).then(() => {
            this.modalController.dismiss();
        });
    }

    close() {
        this.modalController.dismiss();
    }

}
